<form name="admin-form" Admin="ngForm">
  <div class="admin-content">
    <div class="d-flex flex-column full-height">
      <app-breadcrumb class="hide-mobile" [model]="breadCrumb"></app-breadcrumb>
    </div>
  </div>
</form>

<div class="main-content">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <h1 class="title">Tools ({{toolCount}})</h1>
      <button type="button" class="links" (click)="getAllMeasurements()">Export Cast Member Data</button>
      <div>
      <button type="button" class="links" (click)="getAllCharacterMeasurements()">Export Character Data</button>
      </div>
      <div>
        <button type="button" class="links" (click)="openUploadModal()">Upload Cast Measurements</button>
      </div>
    </div>
  </div>
</div>

<app-upload-measurements-modal></app-upload-measurements-modal>